import React from 'react';
import MentorGrid from './mentorSlider';

export default function AllMentorsPage() {
  return (
    <div className="min-h-screen bg-primary-light-4 py-10">
      <MentorGrid showSearch={true} showAll={true} title="All Mentors" />
    </div>
  );
}
